<template>
  <div class="header-container">
    <img :src="require('@/assets/setting/avatar.png')" alt="" />
    <Search
      class="van-hairline--surround"
      v-model="value"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    />
  </div>
</template>

<script>
import { Search } from 'vant'
export default {
  components: {
    Search,
  },
  data() {
    return {
      value: null,
    }
  },
  methods: {
    onSearch() {
      this.$emit('search')
    },
  },
}
</script>

<style lang="less" scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  img {
    width: 70px;
    height: 70px;
  }
  .van-search {
    flex: 1;
    padding: 0;
    margin-left: 30px;
    &::after {
      border-color: #e82035;
      border-radius: 72px;
    }
    & /deep/ .van-cell {
      display: flex;
      align-items: center;
    }
    & /deep/ .van-search__content {
      background-color: transparent;
      .van-field__left-icon {
        color: #e82035;
        font-size: 32px;
      }
      .van-field__control {
        font-size: 28px;
        line-height: 1em;
      }
    }
  }
}
</style>